import { useMutation, useQuery } from "@tanstack/react-query";
import {
  ContactRequest,
  Favorites,
  ImageRequest,
  ProfileInterested,
  ProfileVisited,
  removeFromProfile,
  ProfileInterestedCount,
  ImageRequestCount,
} from "api/engage";
import AlertNotification from "components/CustomWidgets/alertNotification";

export const useProfileVisited = (
  { page, limit, profile_type, filter_data },
  options = {},
) => {
  return useQuery({
    queryKey: ["profileVisited", { page, limit, profile_type, filter_data }],
    queryFn: ProfileVisited,
    ...options,
  });
};

export const useProfileInterested = (
  { page, limit, profile_type, filter_data },
  options = {},
) => {
  return useQuery({
    queryKey: ["profileInterested", { page, limit, profile_type, filter_data }],
    queryFn: ProfileInterested,
    ...options,
  });
};

export const useProfileInterestedCount = (profile_type, options = {}) => {
  return useQuery({
    queryKey: ["profileInterestedCount", profile_type],
    queryFn: ProfileInterestedCount,
    ...options,
  });
};

export const useContactRequest = (
  { page, limit, profile_type, filter_data },
  options = {},
) => {
  return useQuery({
    queryKey: ["contactRequest", { page, limit, profile_type, filter_data }],
    queryFn: ContactRequest,
    ...options,
  });
};

export const useFavorites = (
  { page, limit, profile_type, filter_data },
  options = {},
) => {
  return useQuery({
    queryKey: ["favorites", { page, limit, profile_type, filter_data }],
    queryFn: Favorites,
    ...options,
  });
};

export const useImageRequest = (
  { page, limit, profile_type, filter_data },
  options = {},
) => {
  return useQuery({
    queryKey: ["imageRequest", { page, limit, profile_type, filter_data }],
    queryFn: ImageRequest,
    ...options,
  });
};

export const useImageRequestCount = (profile_type, options = {}) => {
  return useQuery({
    queryKey: ["imageRequestCount", profile_type],
    queryFn: ImageRequestCount,
    ...options,
  });
};

export const useRemoveFromProfile = (options = {}) => {
  return useMutation({
    mutationFn: removeFromProfile,
    onSuccess: (data, variables, context) => {
      AlertNotification("success", data.message);
      options.onSuccess?.(data, variables, context);
    },
  });
};
